export { CompanyBankAccountsTable } from './CompanyBankAccountsTable'
